import {NavLink} from "react-router-dom";
import { useEffect } from "react";

function Section_Desktop(props) {
  const isExpanded = props.expandedSection === props.sectionTitle;

  useEffect(() => {
    if (props.pages && props.sectionTitle) {
      let url = window.location.href;
      let pagesFiltered = props.pages.filter((f) => url.includes(f.urlPath));
      if (pagesFiltered.length > 0 && !isExpanded) {
        props.onSectionToggle(props.sectionTitle);
      }
    }
  }, []);

  const toggleSection = () => {
     props.onSectionToggle(isExpanded ? null : props.sectionTitle);
  };

  return (
    <>
      <div className="sectionTitle" onClick={toggleSection}>
        <span className="material-symbols-outlined">
          {isExpanded ? "keyboard_arrow_down" : "keyboard_arrow_right"}
        </span>
        <h3 style={{ fontSize: "16px", fontWeight: "Medium" }}>
          {props.sectionTitle}
        </h3>
      </div>
      <ul style={{ display: isExpanded ? "flex" : "none" }}>
        {props.pages.map((p) => (
          <NavLink key={p.id} to={p.urlPath} className="NavPg" replace>
            <span className="material-symbols-outlined">{p.icon}</span>
            <span>{p.pgName}</span>
          </NavLink>
        ))}
      </ul>
    </>
  );
}

export default Section_Desktop;
